<template>
  <home-page :bgColor="bgColor"></home-page>
</template>

<script>
// @ is an alias to /src
import HomePage from "@/components/HomePage.vue";

export default {
  name: "HomeView",
  components: {
    HomePage,
  },
  props: {
    bgColor: {
      type: String,
      required: true,
    },
  },
  mounted() {
    //console.log("Color de fondo recibido en HomeView:", this.bgColor); // Verifica el color en la consola
  },
};
</script>

<style>
</style>